import Grid from '@material-ui/core/Grid';
import {
  Menu,
  MenuItem,
  Typography,
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core';

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { baseTheme } from '../../theme';

import LibraryListItem from '../../components/library-components/library-list-item';
import LibraryEmptyList from '../../components/library-components/library-empty';
import LibraryActionBar from '../../components/library-components/library-action-bar';
import { getLibraryPostsAction, getMoreLibraryPostsActions } from '../../store';
import InfiniteScroll from 'react-infinite-scroller';
import { deleteLibraryPostAction } from '../../store/library/actions';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(2),
    },
    pageHeading: {
      fontSize: '1.6em',
      color: theme.palette.primary.main,
      fontWeight: 'normal',
      padding: theme.spacing(0),
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(0),
      marginBottom: theme.spacing(1),
      marginLeft: theme.spacing(0),
    },
    listRoot: {
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      transition: theme.transitions.create('all', {
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    loadSpinner: {
      padding: theme.spacing(1),
      margin: '0 auto',
    },
    infiniteScroll: {
      width: '100%',
    },
    menuItem: {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.primary.light,
      '&:hover': {
        backgroundColor: theme.palette.warning.light,
      },
    },
  }),
);

export default function LibraryPage() {
  const classes = useStyles(baseTheme);
  const dispatch = useDispatch();
  const loaded = useSelector((state: any) => state.library.loaded);
  const currUser = useSelector((state: any) => state.auth.currUser);
  const followedPost = useSelector((state: any) => state.library.list);
  const listConfig = useSelector((state: any) => state.library.listConfig);
  const [anchorEl, setAnchorEl] = useState(null);
  const [activePostID, setActivePostId] = useState(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    if (!loaded) {
      getLibraryPostsAction(currUser.uid, listConfig, dispatch);
    }
  }, [loaded, listConfig, dispatch, currUser]);

  const listFollow = () => followedPost
    .map((post: any, index: number) =>
      (<LibraryListItem {...post} key={index} handleIconClick={handleIconClick} />));

  const emptyList = () => (<LibraryEmptyList />);

  const loadMoreLibrary = () => {
    getMoreLibraryPostsActions(currUser.uid, listConfig, dispatch);
  };

  const handleIconClick = (postId: any) => (event: any) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setActivePostId(postId);
  };

  const handleDelete = (event: any) => {
    event.stopPropagation();
    setAnchorEl(null);
    if (activePostID) {
      deleteLibraryPostAction(activePostID, dispatch);
      setActivePostId(null);
    }
  };

  const handleClose = (event: any) => {
    event.stopPropagation();
    setAnchorEl(null);
    setActivePostId(null);
  };

  return (
    <Grid item container className={classes.root} xs={12}>
      <LibraryActionBar />

      <Grid item container direction="column">
        {followedPost.length ?
          (<InfiniteScroll
            pageStart={0}
            loadMore={loadMoreLibrary}
            hasMore={loaded && listConfig.moreItems}
            initialLoad={false}
            className={classes.infiniteScroll}
          >
            {listFollow()}
          </InfiniteScroll>)
          : emptyList()
        }
      </Grid>

      <Menu
        id="library-actions-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
      >
        <MenuItem key="delete-group" onClick={handleDelete} className={classes.menuItem}>
          Delete
        </MenuItem>
      </Menu>
    </Grid>
  );
}
